import { render, staticRenderFns } from "./id-card.vue?vue&type=template&id=6761c87c&scoped=true"
import script from "./id-card.vue?vue&type=script&lang=js"
export * from "./id-card.vue?vue&type=script&lang=js"
import style0 from "./id-card.vue?vue&type=style&index=0&id=6761c87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6761c87c",
  null
  
)

export default component.exports